import React from "react";
import { Link } from "react-router-dom";

function Navbar() {
  return (
    <nav className="navbar">
      <h2>EV Dashboard</h2>
      <div className="nav-links">
        <Link to="/dashboard">Dashboard</Link>
        <Link to="/billing">Billing</Link>
        <Link to="/notifications">Notifications</Link>
        <Link to="/audit">Audit Logs</Link>
      </div>
    </nav>
  );
}

export default Navbar;
